import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade';
import { ANALYTICS_CTA_CLICK_PROPS_MAP } from 'components/empty_state/constants';
import { resetShowAiNotetakerBetaModal } from 'features/billing';
import { showAcknowledgementModal, MR_ONBOARDING_WIZARD, useEnableNotetakerWithLoader, useGetMeetingIntelligenceUserSettingsQuery, useNotetakerEntitled, useNotetakerFreeMeetingsQuota, getNotetakerAccessStartedAction } from 'features/meeting_intelligence';
import { useTrack, TRACKING_EVENT_NAMES } from 'hooks/analytics_events';
import { useNotetakerFiveFreeRecapsExperiment } from 'hooks/useNotetakerFiveFreeRecapsExperiment';
import { useNotetakerFreeExperiment } from 'hooks/useNotetakerFreeExperiment';
const notetakerButtonIsSampleRecapCss = "nthx5dj";
const notetakerButtonIsTabletCss = "n1mnqmvx";
const notetakerButtonIsPhoneCss = "n88lj78";
const notetakerButtonCss = "nxumpu5";
const NotetakerButtonWrapper = forwardRef((props, ref) => {
  const {
    isSampleRecap,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTablet = useDeviceType('isTablet');
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(notetakerButtonCss, {
    [notetakerButtonIsSampleRecapCss]: isSampleRecap,
    [notetakerButtonIsTabletCss]: isTablet,
    [notetakerButtonIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const NotetakerButton = ({
  contentKey,
  text,
  isSampleRecap = false
}) => {
  const track = useTrack();
  const dispatch = useDispatch();
  const enforceUpgrade = useEnforceUpgrade('meeting_intelligence');
  // 'meeting_intelligence' here is the billing feature key, NOT the legacy meeting_intelligence feature flag
  const {
    isEntitled: isNotetakerEntitled
  } = useNotetakerEntitled();
  const enableNotetaker = useEnableNotetakerWithLoader();
  const {
    data: meetingIntelligenceData
  } = useGetMeetingIntelligenceUserSettingsQuery();
  const {
    isInExperiment: isInNotetakerFreeExperiment
  } = useNotetakerFreeExperiment();
  const {
    isInExperiment: isInNotetakerFiveFreeRecapsExperiment
  } = useNotetakerFiveFreeRecapsExperiment();
  const isInNotetakerFreeAccessExperiment = isInNotetakerFreeExperiment || isInNotetakerFiveFreeRecapsExperiment;
  const {
    hasRemainingFreeMeetings,
    isLoading: isQuotaLoading
  } = useNotetakerFreeMeetingsQuota({
    skip: !isInNotetakerFreeAccessExperiment
  });
  if (!isNotetakerEntitled && !isInNotetakerFreeAccessExperiment) return null;
  const handleClick = () => {
    // Prevent modal from showing if admin has disabled notetaker for the organization
    if (meetingIntelligenceData?.adminDisabledNotetaker) {
      return;
    }
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      entities: ['attribution', 'organization', 'user'],
      properties: {
        ...ANALYTICS_CTA_CLICK_PROPS_MAP[contentKey],
        action: getNotetakerAccessStartedAction(isInNotetakerFreeExperiment)
      }
    });
    if (isInNotetakerFreeExperiment && (isQuotaLoading || hasRemainingFreeMeetings)) {
      dispatch(showAcknowledgementModal(MR_ONBOARDING_WIZARD.USER_TRIGGERED));
      dispatch(resetShowAiNotetakerBetaModal());
    } else if (hasRemainingFreeMeetings) {
      enableNotetaker();
    } else if (!isQuotaLoading) {
      enforceUpgrade(enableNotetaker);
    }
  };
  return <NotetakerButtonWrapper isSampleRecap={isSampleRecap}>
      <Button decoration="ai" onClick={handleClick}>
        {text}
      </Button>
    </NotetakerButtonWrapper>;
};

require("./notetaker_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notetaker_button.js");